import React from 'react';

import { useMediaQuery, useTheme } from '@material-ui/core';

import { UiDropdownOptionWithTooltip } from '../ui/ui-dropdown-option-with-tooltip';

import { getCustomerLogoPath } from '../util/get-customer-logo-path';

type InputProps = {
  org: Org;
  Icon?: React.ReactNode;
  isSelected: boolean;
  isSelectable?: boolean;
  isTitleOption?: boolean;
};

export const OrgDropdownOption = ({
  org,
  Icon,
  isSelected,
  isSelectable,
  isTitleOption,
}: InputProps) => {
  const theme = useTheme();
  const isOnMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <UiDropdownOptionWithTooltip
      tooltipText={org.name}
      option={org.name}
      Icon={Icon}
      Image={
        <div
          className={`navDropdown-imageContainer ${
            isOnMobile ? 'navDropdown-imageContainer-mobile' : ''
          }`}
        >
          <img
            className={isOnMobile ? 'navDropdown-image-mobile' : 'navDropdown-image'}
            src={getCustomerLogoPath(org)}
            alt={org.name}
          />
        </div>
      }
      isSelected={isSelected}
      isSelectable={isSelectable}
      isTitleOption={isTitleOption}
    />
  );
};
